module.exports = import("/document-ui/assets/remoteEntry.js");